import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import Mask from '../mask';
import Icon from '../icon';
const Toast = ({ icon, iconSize, visible = true, children }) => (_jsxs("div", Object.assign({ style: { display: visible ? 'block' : 'none' } }, { children: [_jsx(Mask, { transparent: true }), _jsxs("div", Object.assign({ className: classNames('taro-toast', {
                'taro-toast_none': !icon
            }) }, { children: [!!icon && _jsx(Icon, { className: 'taro-toast_icon', type: icon, size: iconSize }), _jsx("p", Object.assign({ className: 'taro-toast_content' }, { children: children }))] }))] })));
export default Toast;
